import { useNavigate, useLocation } from "react-router";
import { useMeals } from "../contexts/UserMealsContext";
import { useMealTags } from "../contexts/MealTagContext";
import { useIngredientUnits } from "../contexts/IngredientUnitContext";
import { UserMealForm } from "../components/UserMealPage/UserMealForm";
import { MealParsingApi } from "../api/MealParsingApi";
import { mapAiDraftToForm } from "../utils/mapAiDraftToForm";
import { useState } from "react";
import { LoadingComponent } from "../components/LoadingComponent";

export function CreateMealPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { createMeal } = useMeals();
  const { mealTags } = useMealTags();
  const { ingredientUnits } = useIngredientUnits();

  const [isLoading, setIsLoading] = useState(false);

  const initialForm = location.state?.aiDraft
    ? mapAiDraftToForm(
        location.state.aiDraft,
        ingredientUnits.map((u) => u.unit),
      )
    : null;

  const handleAiParse = (mode, value) =>
    mode === "url"
      ? MealParsingApi.parseMealFromUrl(value)
      : MealParsingApi.parseMealText(value);

  const handleSubmit = async (form) => {
    setIsLoading(true);

    try {
      const mealTagList = form.mealTagList.map((tag) => ({
        tagId: tag.tagId,
      }));

      const ingredientList = form.ingredients.map((ing) => {
        const unitObj = ingredientUnits.find((u) => u.unit === ing.unit);
        return {
          ingredientName: ing.name.trim(),
          ingredientQuantity: ing.quantity,
          unitId: unitObj?.unitId ?? null,
        };
      });

      const createMealRequest = {
        mealName: form.mealName,
        breakfast: form.mealCategories.breakfast,
        lunch: form.mealCategories.lunch,
        dinner: form.mealCategories.dinner,
        snack: form.mealCategories.snack,
        ingredientList,
        mealTagList,
        timeMins: form.timeMins,
        servings: form.servings,
      };

      await createMeal(createMealRequest);
      navigate("/MealList");
    } catch (err) {
      // optional: show toast / UI error
      console.error("Failed to create meal: ", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      {isLoading ? (
        <LoadingComponent message={"Creating your meal..."} />
      ) : (
        <UserMealForm
          mealData={initialForm}
          onSubmit={handleSubmit}
          onCancel={() => navigate("/MealList")}
          onAiParse={handleAiParse}
          completeNavigateUrl="/MealList"
          heading={"Create Meal"}
          confirmButtonText={"Create Meal"}
          userMealTags={mealTags}
          ingredientUnits={ingredientUnits.map((u) => u.unit)}
        />
      )}
    </div>
  );
}
